/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".text-size[_ngcontent-%COMP%], .text-size[_ngcontent-%COMP%]   p[_ngcontent-%COMP%]{font-size:12px}"];
export { styles as styles };
